import {initializeSentry} from '@js/modules/sentry';
import {patchWorkerErrorReporting} from '@js/modules/workerErrorReporting';


initializeSentry();

// Forward uncaught errors from every Web Worker to Sentry — they don't
// reach the main-thread handler on their own. Must run before any worker is created.
patchWorkerErrorReporting();

//     document.addEventListener('DOMContentLoaded', function () {
//         setTimeout(function () {
//         }, 3000);
//     });
